import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { lsgPre } from '../../config/prefix.js';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { Host } from '../../utils/Host.js';
import { fComp } from '../../utils/React.js';
import { BadgePresentation } from '../Badge/BadgePresentation.js';
import { ParagraphPresentation } from '../Paragraph/ParagraphPresentation.js';
import { ThumbnailPresentation } from '../Thumbnail/ThumbnailPresentation.js';
import { hostClass } from './TwoLineItem.styles.js';

var defaultProps = {
  componentSpacing: "medium",
  badgeLook: "primary"
};
var TwoLineItemPresentation = fComp(function (props) {
  var _cleanupClassObject, _cleanupClassObject3, _cleanupClassObject4;
  var id = props.id,
    className = props.className,
    icon = props.icon,
    iconName = props.iconName,
    iconVariant = props.iconVariant,
    iconTitle = props.iconTitle,
    text = props.text,
    src = props.src,
    headline = props.headline,
    subline = props.subline,
    sublineAs = props.sublineAs,
    centeredLayout = props.centeredLayout,
    componentSpacing = props.componentSpacing,
    badgeText = props.badgeText,
    badgeIcon = props.badgeIcon,
    badgeLook = props.badgeLook;
  var hasThumb = !!text || !!iconName || !!icon || !!src;
  var hasSubline = !!subline;
  return /*#__PURE__*/React.createElement(Host, {
    id: id,
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, hostClass, true), _defineProperty(_cleanupClassObject, className, !!className), _defineProperty(_cleanupClassObject, "".concat(lsgPre, "-centered-layout"), centeredLayout), _defineProperty(_cleanupClassObject, "".concat(lsgPre, "-spacing-").concat(componentSpacing), componentSpacing), _cleanupClassObject))
  }, hasThumb && /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject(_defineProperty({}, "".concat(hostClass, "__thumbnail"), true))
  }, /*#__PURE__*/React.createElement(ThumbnailPresentation, {
    icon: icon,
    iconName: iconName,
    iconVariant: iconVariant,
    iconTitle: iconTitle,
    text: text,
    src: src,
    noMargin: !centeredLayout
  })), headline && /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "__text-container")
  }, /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject((_cleanupClassObject3 = {}, _defineProperty(_cleanupClassObject3, "".concat(hostClass, "__label-text"), true), _defineProperty(_cleanupClassObject3, "".concat(hostClass, "__label-text--centered"), !hasSubline), _cleanupClassObject3))
  }, headline), subline && /*#__PURE__*/React.createElement(ParagraphPresentation, {
    as: sublineAs,
    className: "".concat(hostClass, "__helper-text"),
    size: "helper-text",
    noMargin: true
  }, subline)), /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject((_cleanupClassObject4 = {}, _defineProperty(_cleanupClassObject4, "".concat(hostClass, "-badge-container"), true), _defineProperty(_cleanupClassObject4, "".concat(hostClass, "-badge-container__centered"), centeredLayout), _cleanupClassObject4))
  }, (badgeText && !(badgeText === null || badgeText === void 0 ? void 0 : badgeText.trim()) || badgeIcon) && /*#__PURE__*/React.createElement(BadgePresentation, {
    type: badgeText ? "text" : "icon",
    text: badgeText,
    icon: badgeIcon,
    look: badgeLook,
    size: "default"
  })));
}, defaultProps);
TwoLineItemPresentation.displayName = "TwoLineItemPresentation";

export { TwoLineItemPresentation };
